import * as React from 'react';
import { Box, TextField, Grid, FormControlLabel, Checkbox, Button, Collapse, Alert } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { useState } from 'react';
// import { useRef } from 'react';
// import emailjs from '@emailjs/browser';

export default function Contactform() {
    const [wasSend, setWasSend] = useState(false);
    const [wasSuccessfully, setWasSuccessfully] = useState(true);
    const [toOftenTry, setToOftenTry] = useState(false);
    const [currentContact, setCurrentContact] = useState({
        FirstName: "",
        LastName: "",
        Email: "",
        Company: "",
        Message: ""
    });

    const handleChange = (event) => {
        let tmpObject = { ...currentContact };
        tmpObject[event.target.name] = event.target.value;
        setCurrentContact(tmpObject);
    };

    async function handleClickSend() {
        setWasSuccessfully(true);
        setWasSend(false);
        setToOftenTry(false);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(currentContact)
        };
  
        fetch('/kemto_mail.php', requestOptions)
            .then(res => {
                if (res.status === 200) return res.json();
                else if (res.status === 423) throw Error("Too many attempts.");
                else throw Error(res.Error);
            })
            .then(() => {
                setCurrentContact({ FirstName: "", LastName: "", Email: "", Company: "", Message: "" });
                setWasSend(true);
            })
            .catch(error => {
                if (error.message === "Too many attempts.") {
                    setToOftenTry(true);
                } else {
                    setWasSuccessfully(false);
                }
            });
    }

    async function handleSubmit(e) {
        e.preventDefault();
        handleClickSend();
        e.target.reset();
    }

    return (
        <Box className="contactWrapper">

<Box className='contactBottomWrapper'>
                {/* <form action="contact.php"> */}
                {/* <form ref={form} onSubmit={sendEmail}> */}
                <form onSubmit={handleSubmit}>

                        <Grid item xs={12} sm={12} className='contactInputWrapper'>
                            <TextField type="text" required id="vorname" name='FirstName' onChange={handleChange} label="Vorname" variant="standard" className='contactInput'/>
                        </Grid>
                        <Grid item xs={12} sm={12} className='contactInputWrapper'>
                            <TextField type="text" required id="nachname" name='LastName' onChange={handleChange} label="Nachname" variant="standard" className='contactInput' />
                        </Grid>

                    <Grid item xs={12} sm={12} className='contactInputWrapper'>
                            <TextField type="tel" required id="company" name='Company' onChange={handleChange} label="Firma" variant="standard" className='contactInput' />
                        </Grid>

                        <Grid item xs={12} sm={12} className='contactInputWrapper'>
                            <TextField type="email" required id="email" name='Email' onChange={handleChange} label="E-Mail" variant="standard" className='contactInput' />
                        </Grid>

 
                        <Grid item xs={12} sm={12} className='contactInputWrapper'>
                            <TextField id="nachricht" name='Message' onChange={handleChange} label="Nachricht" multiline rows={4} variant="standard" className='contactInput' />
                        </Grid>

                    <Box className='contactFormTopGrid' id="contactFormBottomControls">
                    <p className='contactInfoText'>Mit dem Absenden des Formulars stimmen Sie unserer <a href="/datenschutz" >Datenschutzerklärung</a> zu.</p>
                        <Grid item xs={12} sm={4}>
                            <Button variant='contained' color='primary' className='contactFormBtn' type="submit" id="submitBtn">Absenden</Button>
                        </Grid>
                    </Box>
                </form>
            </Box>


            <Collapse key="error-send" in={!wasSuccessfully}>
                <Alert severity='error'>
                    Ihre Anfrage konnte nicht übermittelt werden. 
                </Alert>
            </Collapse>

            <Collapse key="success-send" in={wasSend}>
                <Alert severity='success'>
                    Ihre Anfrage wurde erfolgreich übermittelt!
                </Alert>
            </Collapse>

            <Collapse key="locked-send" in={toOftenTry}>
                <Alert severity='warning'>
                    Sie haben innerhalb einer Stunde bereits zwei Anfragen gesendet!
                </Alert>
            </Collapse>


            <Box>
                <Grid container spacing={2} id="formMessageBox">
                    <Grid item xs={12} sm={12}>
                        <p id="formsuccess">Ihre Daten wurden erfolgeich gesendet. Wir werden uns so schnell wie möglich bei Ihnen melden.</p>
                        <p id="formFail">Es gab einen Fehler beim Senden der Daten. Bitte versuchen Sie es noch einmal oder erreichen Sie uns Telefonisch.</p>
                    </Grid>
                </Grid>

            </Box>

        </Box >

    );
}